// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact_section{
  display: flex;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  align-items: center;
}

.contact_section{
  .card{
    position: relative;
    align-items: center;
    color: var(--text-color);
    width: 60%;
    box-shadow: 3px 3px 12px -5px var(--text-color);
        border-radius: 15px;
        background: rgb(255, 255, 255, 0.1);
        display: flex;
        flex-wrap: wrap;
        border-top: 1px solid var(--text-color);
        border-left: 1px solid var(--text-color);
        -webkit-backdrop-filter: blur(3px);
                backdrop-filter: blur(3px);
        margin-bottom: 1.5rem;
  }
}

.contact_section p{
  text-align: justify;
  padding: 0.5rem;
}

.contact-outer_container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin:auto;
    margin-top: 6%;
    width: -moz-fit-content;
    width: fit-content;
    height: -moz-fit-content;
    height: fit-content;
    
    
}
.contact-outer_container span{
    color: var(--main-color);
    font-size: 40px;
    font-weight: 700;   
    align-items: center;
}

.contact-outer_container h1{
    color:var(--text-color);
    font-size: 40px;
    font-weight: 700;
    margin-bottom: 20px;
    transition: opacity 0.9s ease-in-out,transform 0.9s ease-in-out;  
}

.contact-outer_container .active_contact_h1{
  opacity: 1;
  transform: translateY(0);
}

.contact-inner_container{
    display: flex;
    width:-moz-fit-content;
    width:fit-content;
    row-gap: 10px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: 80%;
    animation: opac 0.9s ease forwards;
}

.input-container{
    display:flex ;
    flex-direction: column;
    flex-wrap: wrap;
    width: -moz-fit-content;
    width: fit-content;
    row-gap: 5px;
    justify-content: center;
    align-items: center;
}

input{
    width: 100%;
    opacity: 1;
    border-radius: 10px;
    padding-inline-start: 10px;
    height: 45px;
}

.input-with-icon {
    display: flex;
    position: relative;
    width: 350px;
  }

.input-with-icon i.fa-check-circle,i.fa-times-circle  {
    position: absolute;
    right: 10px;
    top: calc(50% - 10px);
    bottom: 0;
    margin: auto;
    font-size: 20px;
    color: var(--main-color);
  }

.input-with-icon #textarea-icon{
    position: absolute;
    right: 14px;
    top:0;
    bottom: 0;
    margin: auto;
    font-size: 20px;
    color: var(--main-color);
  }
  
.input-name{
  transition-property: opacity,transform;
  transition: opacity 0.9s ease-in-out, transform 0.9s ease-in-out ;
  transition-delay: 0.2s,0.2s;
}

.active_input-name{
  opacity: 1;
  transform: translateX(0);
  
}

#input_name{
   background: rgb(255, 255, 255, 0.1);
}

.input-number{
  opacity: 0;
  transform: translateX(100px);
  transition-property: opacity,transform;
  transition: opacity 0.9s ease-in-out, transform 0.9s ease-in-out ;
  transition-delay: 0.2s,0.2s;
  background: rgb(255, 255, 255, 0.1);
}
.active_input-number{
  opacity: 1;
  transform: translateX(0);

}
.input-email{
  opacity: 0;
  transform: translateX(-100px);
  transition-property: opacity,transform;
  transition: opacity 0.9s ease-in-out, transform 0.9s ease-in-out ;
  transition-delay: 0.3s,0.3s;
}
.active_input-email{
  opacity: 1;
  transform: translateX(0);
}
.input-email_subject{
  opacity: 0;
  transform: translateX(100px);
  transition-property: opacity,transform;
  transition: opacity 0.9s ease-in-out, transform 0.9s ease-in-out ;
  transition-delay: 0.3s,0.3s;
}
.active_input-email_subject{
  opacity: 1;
  transform: translateX(0);
}


input:focus {
    outline: var(--main-color);
    box-shadow: 0 0 2px 2px var(--main-color);
  }

textarea:focus{
    outline: var(--main-color);
    box-shadow: 0 0 2px 2px var(--main-color);
}

.form-group{
    display: flex;
    flex-wrap: wrap;
    width:-moz-fit-content;
    width:fit-content;
    column-gap: 5px;
    row-gap: 5px;
    align-items: center;
    justify-content: center;
}

.boxx{
  box-shadow: 20px 20px 50px rgba(0, 0, 0, 0.1);
        border-radius: 15px;
        background: rgb(255, 255, 255, 0.1);
        display: flex;
        flex-wrap: wrap;
        border-top: 1px solid var(--text-color);
        border-left: 1px solid var(--text-color);
        -webkit-backdrop-filter: blur(3px);
                backdrop-filter: blur(3px);
        color: var(--text-color);
        font-weight: 600;
}

#text-areas{
    display: flex;
    width:100%;
    justify-content: center;
    align-items: center;
}

#text-areas textarea{
    position: relative;
    width:100%;
    height: 250px;
    padding-inline: 10px;
    border-radius: 10px;
}

#text-areas .input-text{
  opacity: 0;
  transform: translateY(100px);
  transition-property: opacity,transform;
  transition: opacity 0.9s ease-in-out, transform 0.9s ease-in-out ;
  transition-delay: 0.4s,0.4s;
}

#text-areas .active_input-text{
  opacity: 1;
  transform: translateY(0);
}

#contact-send{
    margin-top: 10px;
}

.contact-btn{
  opacity: 0;
  scale: 0;
  transition-property: opacity,transform;
  transition: scale 0.9s ease-in-out, transform 0.9s ease-in-out ;
  transition-delay: 0.8s,0.8s;
  cursor: pointer;
}

.active_contact-btn{
  opacity: 1;
  scale: 1;
}

@keyframes rotateShake {
    0% {
      transform: rotate(0deg);
    }
    10% {
      transform: rotate(-10deg);
    }
    20% {
      transform: rotate(10deg);
    }
    30% {
      transform: rotate(-10deg);
    }
    40% {
      transform: rotate(10deg);
    }
    50% {
      transform: rotate(-10deg);
    }
    60% {
      transform: rotate(10deg);
    }
    70% {
      transform: rotate(-10deg);
    }
    80% {
      transform: rotate(10deg);
    }
    90% {
      transform: rotate(-10deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  @keyframes rotateShake1 {
    0% {
      transform: rotate(0deg);
    }
    10% {
      transform: rotate(-1deg);
    }
    20% {
      transform: rotate(1deg);
    }
    30% {
      transform: rotate(-1deg);
    }
    40% {
      transform: rotate(1deg);
    }
    50% {
      transform: rotate(-1deg);
    }
    60% {
      transform: rotate(1deg);
    }
    70% {
      transform: rotate(-1deg);
    }
    80% {
      transform: rotate(1deg);
    }
    90% {
      transform: rotate(-1deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  
  .fa-shake {
    animation-name: rotateShake;
    animation-duration: 1s;
    animation-iteration-count: 1;
  }
  .fa-shake1 {
    animation-name: rotateShake1;
    animation-duration: 1s;
    animation-iteration-count: 1;
  }
  
@keyframes opac{
    0%{
      opacity: 1;
    }
    100%{
      opacity: 1;
    }
   }

   @media(max-width:992px){
    .form-group{
      width: 100%;  
    }
    .contact-inner_container{
      margin-top: 10%;
    }
    .contact_section{
      height: 100vh;
    }
    .contact_section{
      .card{
        display: none;
      }
    }
    .contact-outer_container span{
      font-size: 35px;
    }
    .contact-outer_container h1{
      margin-bottom: 5px;
      font-size: 35px;
    }
    .contact-outer_container{
      position: relative;
      top: 55px;
    }
    #text-areas{
      width:100%;
  }
    }
    .btnnnn{
      .btn {
      align-self: center;
      display:block;
      margin: 0rem 0rem 3rem 0;
      background: var(--main-color);
      color: var(--text-color);    
      padding: 0.8rem 1.5rem;
      border-radius: 4rem;
      box-shadow: 0 0 0.5rem var(--text-color);
      width: -moz-fit-content;
      width: fit-content;
      font-size: 1.4rem;
      letter-spacing: 0.1rem;
      font-weight: 600;
      transition: .5s ease;
      }     
}`, "",{"version":3,"sources":["webpack://./src/components/Contact/Contacts.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,UAAU;IACV,+CAA+C;QAC3C,mBAAmB;QACnB,mCAAmC;QACnC,aAAa;QACb,eAAe;QACf,uCAAuC;QACvC,wCAAwC;QACxC,kCAA0B;gBAA1B,0BAA0B;QAC1B,qBAAqB;EAC3B;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,cAAc;IACd,uBAAkB;IAAlB,kBAAkB;IAClB,wBAAmB;IAAnB,mBAAmB;;;AAGvB;AACA;IACI,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,+DAA+D;AACnE;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAiB;IAAjB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,uBAAkB;IAAlB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;EACd;;AAEF;IACI,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,SAAS;IACT,YAAY;IACZ,eAAe;IACf,wBAAwB;EAC1B;;AAEF;IACI,kBAAkB;IAClB,WAAW;IACX,KAAK;IACL,SAAS;IACT,YAAY;IACZ,eAAe;IACf,wBAAwB;EAC1B;;AAEF;EACE,sCAAsC;EACtC,iEAAiE;EACjE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,wBAAwB;;AAE1B;;AAEA;GACG,mCAAmC;AACtC;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,sCAAsC;EACtC,iEAAiE;EACjE,2BAA2B;EAC3B,mCAAmC;AACrC;AACA;EACE,UAAU;EACV,wBAAwB;;AAE1B;AACA;EACE,UAAU;EACV,6BAA6B;EAC7B,sCAAsC;EACtC,iEAAiE;EACjE,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,4BAA4B;EAC5B,sCAAsC;EACtC,iEAAiE;EACjE,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;;;AAGA;IACI,0BAA0B;IAC1B,yCAAyC;EAC3C;;AAEF;IACI,0BAA0B;IAC1B,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,sBAAiB;IAAjB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;EACE,6CAA6C;QACvC,mBAAmB;QACnB,mCAAmC;QACnC,aAAa;QACb,eAAe;QACf,uCAAuC;QACvC,wCAAwC;QACxC,kCAA0B;gBAA1B,0BAA0B;QAC1B,wBAAwB;QACxB,gBAAgB;AACxB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,sCAAsC;EACtC,iEAAiE;EACjE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,sCAAsC;EACtC,+DAA+D;EAC/D,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;IACI;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,yBAAyB;IAC3B;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,yBAAyB;IAC3B;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,yBAAyB;IAC3B;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,yBAAyB;IAC3B;IACA;MACE,uBAAuB;IACzB;EACF;EACA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,uBAAuB;IACzB;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,uBAAuB;IACzB;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,uBAAuB;IACzB;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,uBAAuB;IACzB;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,uBAAuB;IACzB;EACF;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;EAC9B;EACA;IACE,4BAA4B;IAC5B,sBAAsB;IACtB,4BAA4B;EAC9B;;AAEF;IACI;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;GACD;;GAEA;IACC;MACE,WAAW;IACb;IACA;MACE,eAAe;IACjB;IACA;MACE,aAAa;IACf;IACA;MACE;QACE,aAAa;MACf;IACF;IACA;MACE,eAAe;IACjB;IACA;MACE,kBAAkB;MAClB,eAAe;IACjB;IACA;MACE,kBAAkB;MAClB,SAAS;IACX;IACA;MACE,UAAU;EACd;IACE;IACA;MACE;MACA,kBAAkB;MAClB,aAAa;MACb,wBAAwB;MACxB,6BAA6B;MAC7B,wBAAwB;MACxB,sBAAsB;MACtB,mBAAmB;MACnB,wCAAwC;MACxC,uBAAkB;MAAlB,kBAAkB;MAClB,iBAAiB;MACjB,sBAAsB;MACtB,gBAAgB;MAChB,oBAAoB;MACpB;AACN","sourcesContent":[".contact_section{\n  display: flex;\n  height: 100vh;\n  width: 100%;\n  overflow: hidden;\n  align-items: center;\n}\n\n.contact_section{\n  .card{\n    position: relative;\n    align-items: center;\n    color: var(--text-color);\n    width: 60%;\n    box-shadow: 3px 3px 12px -5px var(--text-color);\n        border-radius: 15px;\n        background: rgb(255, 255, 255, 0.1);\n        display: flex;\n        flex-wrap: wrap;\n        border-top: 1px solid var(--text-color);\n        border-left: 1px solid var(--text-color);\n        backdrop-filter: blur(3px);\n        margin-bottom: 1.5rem;\n  }\n}\n\n.contact_section p{\n  text-align: justify;\n  padding: 0.5rem;\n}\n\n.contact-outer_container{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    margin:auto;\n    margin-top: 6%;\n    width: fit-content;\n    height: fit-content;\n    \n    \n}\n.contact-outer_container span{\n    color: var(--main-color);\n    font-size: 40px;\n    font-weight: 700;   \n    align-items: center;\n}\n\n.contact-outer_container h1{\n    color:var(--text-color);\n    font-size: 40px;\n    font-weight: 700;\n    margin-bottom: 20px;\n    transition: opacity 0.9s ease-in-out,transform 0.9s ease-in-out;  \n}\n\n.contact-outer_container .active_contact_h1{\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.contact-inner_container{\n    display: flex;\n    width:fit-content;\n    row-gap: 10px;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    height: 80%;\n    animation: opac 0.9s ease forwards;\n}\n\n.input-container{\n    display:flex ;\n    flex-direction: column;\n    flex-wrap: wrap;\n    width: fit-content;\n    row-gap: 5px;\n    justify-content: center;\n    align-items: center;\n}\n\ninput{\n    width: 100%;\n    opacity: 1;\n    border-radius: 10px;\n    padding-inline-start: 10px;\n    height: 45px;\n}\n\n.input-with-icon {\n    display: flex;\n    position: relative;\n    width: 350px;\n  }\n\n.input-with-icon i.fa-check-circle,i.fa-times-circle  {\n    position: absolute;\n    right: 10px;\n    top: calc(50% - 10px);\n    bottom: 0;\n    margin: auto;\n    font-size: 20px;\n    color: var(--main-color);\n  }\n\n.input-with-icon #textarea-icon{\n    position: absolute;\n    right: 14px;\n    top:0;\n    bottom: 0;\n    margin: auto;\n    font-size: 20px;\n    color: var(--main-color);\n  }\n  \n.input-name{\n  transition-property: opacity,transform;\n  transition: opacity 0.9s ease-in-out, transform 0.9s ease-in-out ;\n  transition-delay: 0.2s,0.2s;\n}\n\n.active_input-name{\n  opacity: 1;\n  transform: translateX(0);\n  \n}\n\n#input_name{\n   background: rgb(255, 255, 255, 0.1);\n}\n\n.input-number{\n  opacity: 0;\n  transform: translateX(100px);\n  transition-property: opacity,transform;\n  transition: opacity 0.9s ease-in-out, transform 0.9s ease-in-out ;\n  transition-delay: 0.2s,0.2s;\n  background: rgb(255, 255, 255, 0.1);\n}\n.active_input-number{\n  opacity: 1;\n  transform: translateX(0);\n\n}\n.input-email{\n  opacity: 0;\n  transform: translateX(-100px);\n  transition-property: opacity,transform;\n  transition: opacity 0.9s ease-in-out, transform 0.9s ease-in-out ;\n  transition-delay: 0.3s,0.3s;\n}\n.active_input-email{\n  opacity: 1;\n  transform: translateX(0);\n}\n.input-email_subject{\n  opacity: 0;\n  transform: translateX(100px);\n  transition-property: opacity,transform;\n  transition: opacity 0.9s ease-in-out, transform 0.9s ease-in-out ;\n  transition-delay: 0.3s,0.3s;\n}\n.active_input-email_subject{\n  opacity: 1;\n  transform: translateX(0);\n}\n\n\ninput:focus {\n    outline: var(--main-color);\n    box-shadow: 0 0 2px 2px var(--main-color);\n  }\n\ntextarea:focus{\n    outline: var(--main-color);\n    box-shadow: 0 0 2px 2px var(--main-color);\n}\n\n.form-group{\n    display: flex;\n    flex-wrap: wrap;\n    width:fit-content;\n    column-gap: 5px;\n    row-gap: 5px;\n    align-items: center;\n    justify-content: center;\n}\n\n.boxx{\n  box-shadow: 20px 20px 50px rgba(0, 0, 0, 0.1);\n        border-radius: 15px;\n        background: rgb(255, 255, 255, 0.1);\n        display: flex;\n        flex-wrap: wrap;\n        border-top: 1px solid var(--text-color);\n        border-left: 1px solid var(--text-color);\n        backdrop-filter: blur(3px);\n        color: var(--text-color);\n        font-weight: 600;\n}\n\n#text-areas{\n    display: flex;\n    width:100%;\n    justify-content: center;\n    align-items: center;\n}\n\n#text-areas textarea{\n    position: relative;\n    width:100%;\n    height: 250px;\n    padding-inline: 10px;\n    border-radius: 10px;\n}\n\n#text-areas .input-text{\n  opacity: 0;\n  transform: translateY(100px);\n  transition-property: opacity,transform;\n  transition: opacity 0.9s ease-in-out, transform 0.9s ease-in-out ;\n  transition-delay: 0.4s,0.4s;\n}\n\n#text-areas .active_input-text{\n  opacity: 1;\n  transform: translateY(0);\n}\n\n#contact-send{\n    margin-top: 10px;\n}\n\n.contact-btn{\n  opacity: 0;\n  scale: 0;\n  transition-property: opacity,transform;\n  transition: scale 0.9s ease-in-out, transform 0.9s ease-in-out ;\n  transition-delay: 0.8s,0.8s;\n  cursor: pointer;\n}\n\n.active_contact-btn{\n  opacity: 1;\n  scale: 1;\n}\n\n@keyframes rotateShake {\n    0% {\n      transform: rotate(0deg);\n    }\n    10% {\n      transform: rotate(-10deg);\n    }\n    20% {\n      transform: rotate(10deg);\n    }\n    30% {\n      transform: rotate(-10deg);\n    }\n    40% {\n      transform: rotate(10deg);\n    }\n    50% {\n      transform: rotate(-10deg);\n    }\n    60% {\n      transform: rotate(10deg);\n    }\n    70% {\n      transform: rotate(-10deg);\n    }\n    80% {\n      transform: rotate(10deg);\n    }\n    90% {\n      transform: rotate(-10deg);\n    }\n    100% {\n      transform: rotate(0deg);\n    }\n  }\n  @keyframes rotateShake1 {\n    0% {\n      transform: rotate(0deg);\n    }\n    10% {\n      transform: rotate(-1deg);\n    }\n    20% {\n      transform: rotate(1deg);\n    }\n    30% {\n      transform: rotate(-1deg);\n    }\n    40% {\n      transform: rotate(1deg);\n    }\n    50% {\n      transform: rotate(-1deg);\n    }\n    60% {\n      transform: rotate(1deg);\n    }\n    70% {\n      transform: rotate(-1deg);\n    }\n    80% {\n      transform: rotate(1deg);\n    }\n    90% {\n      transform: rotate(-1deg);\n    }\n    100% {\n      transform: rotate(0deg);\n    }\n  }\n  \n  .fa-shake {\n    animation-name: rotateShake;\n    animation-duration: 1s;\n    animation-iteration-count: 1;\n  }\n  .fa-shake1 {\n    animation-name: rotateShake1;\n    animation-duration: 1s;\n    animation-iteration-count: 1;\n  }\n  \n@keyframes opac{\n    0%{\n      opacity: 1;\n    }\n    100%{\n      opacity: 1;\n    }\n   }\n\n   @media(max-width:992px){\n    .form-group{\n      width: 100%;  \n    }\n    .contact-inner_container{\n      margin-top: 10%;\n    }\n    .contact_section{\n      height: 100vh;\n    }\n    .contact_section{\n      .card{\n        display: none;\n      }\n    }\n    .contact-outer_container span{\n      font-size: 35px;\n    }\n    .contact-outer_container h1{\n      margin-bottom: 5px;\n      font-size: 35px;\n    }\n    .contact-outer_container{\n      position: relative;\n      top: 55px;\n    }\n    #text-areas{\n      width:100%;\n  }\n    }\n    .btnnnn{\n      .btn {\n      align-self: center;\n      display:block;\n      margin: 0rem 0rem 3rem 0;\n      background: var(--main-color);\n      color: var(--text-color);    \n      padding: 0.8rem 1.5rem;\n      border-radius: 4rem;\n      box-shadow: 0 0 0.5rem var(--text-color);\n      width: fit-content;\n      font-size: 1.4rem;\n      letter-spacing: 0.1rem;\n      font-weight: 600;\n      transition: .5s ease;\n      }     \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
